import React from 'react';
import { useStateSelector } from 'src/redux';
import useActionsApp from 'src/redux/actionHooks/useActionsApp';
import { Modal } from './Modal';

const WizardRecomendedControls = () => {
  const wizardRecomendedControls = useStateSelector(({ app }) => app.wizardRecomendedControls);
  const { setWizardRecomendedControls } = useActionsApp();

  if (wizardRecomendedControls) return <Modal onClose={() => setWizardRecomendedControls(null)} />;

  return null;
};

export default WizardRecomendedControls;
